export default "__VITE_ASSET__BMcFNdET__"